import React from 'react';
import { IconProps } from './model/IconInterface';

const RulerIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <path d='M3 17 17 3l4 4L7 21z' />
        <path d='M14 6l2 2' />
        <path d='M11 9l1 1' />
        <path d='M8 12l2 2' />
        <path d='M5 15l1 1' />
    </svg>
);

export default RulerIcon;
